import { Box } from '@/components/Box/Box';
import { ResponseErrorType } from '@/types/sharedTypes';
import { AssignedWireType } from '@/types/wireTypes';
import { ViewPaymentDetailsContainer, ViewPaymentDetailsHeader, ViewPaymentDetailsText } from './styles';
import { isCancelledWireStatus } from '@/helpers/wireHelpers';
import { Button } from '@/components/Button/Button';
import { Notification } from '@/components/Notification/Notification';
import { getResponseError } from '@/helpers/apiHelpers/responseHelpers';
import { useSubscriptionStatus } from '@/bundle/shared/hooks/useSubscriptionStatus';
import { useUser } from '@/context/userContext';
import { isPaymentsLimitReached } from '@/helpers/billingHelpers';
import { PaymentsLimitReachedWidget } from '@/bundle/_OrgAdmin/shared/ui/PaymentLimitReachedWidget/PaymentsLimitReachedWidget';

type ViewPaymentDetailsType = {
  wire: AssignedWireType;
  billingEventApiError: ResponseErrorType;
  isShowPaymentDetails: boolean;
  isLoadingBillingEvent: boolean;
  onViewPaymentDetails: () => void;
};

export const ViewPaymentDetails = ({
  wire,
  isShowPaymentDetails,
  billingEventApiError,
  isLoadingBillingEvent,
  onViewPaymentDetails,
}: ViewPaymentDetailsType) => {
  const { user } = useUser();
  const { isViewModeSubscription } = useSubscriptionStatus();
  const isCancelledWire = isCancelledWireStatus(wire?.status);
  const hasViewButton = !isShowPaymentDetails && !isCancelledWire;
  const headerMessage =
    isCancelledWire && !isShowPaymentDetails
      ? 'Wire Info were not viewed before wire cancellation'
      : 'Click here to view wire info.';
  const billingError = getResponseError(billingEventApiError);
  const paymentsLimitReached = isPaymentsLimitReached(user);

  return (
    <>
      {paymentsLimitReached && <PaymentsLimitReachedWidget limitType='payment' />}

      {!paymentsLimitReached && (
        <>
          <ViewPaymentDetailsContainer>
            <Box flexDirection='column' rowGap='4px' mobile={{ alignItems: 'center' }}>
              <ViewPaymentDetailsHeader>Wire Info</ViewPaymentDetailsHeader>
              <ViewPaymentDetailsText>{headerMessage}</ViewPaymentDetailsText>
            </Box>
            {hasViewButton && (
              <Button
                disabled={isViewModeSubscription}
                width={160}
                onClick={onViewPaymentDetails}
                mobileStretch
                isLoading={isLoadingBillingEvent}
              >
                View
              </Button>
            )}
          </ViewPaymentDetailsContainer>
          {billingEventApiError && (
            <Notification variant='error' fontVariant='medium' marginTop='12px'>
              {billingError}
            </Notification>
          )}
        </>
      )}
    </>
  );
};
